<script setup>
</script>

<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 4.5H5C4.44772 4.5 4 4.94772 4 5.5V19.5C4 20.0523 4.44772 20.5 5 20.5H12"
            stroke="#38BDF8"
            stroke-width="1.5"
        />
        <path
            d="M8.57031 12.5H19.9181"
            stroke="#38BDF8"
            stroke-width="1.5"
        />
        <path
            d="M15.9863 8.5L19.9984 12.5406L15.9863 16.5812"
            stroke="#38BDF8"
            stroke-width="1.5"
        />
    </svg>
</template>
